/* eslint-disable @typescript-eslint/no-explicit-any*/
import {
  SET_ME,
  SET_ISPB,
  SET_PENDING_DOCUMENTS,
  SET_PENDING_DOCUMENTS_ERROR,
  SET_PENDING_DOCUMENTS_UPLOAD_SUCCESS,
  MY_USERS,
  MY_USERS_COUNT,
  AVAILABLE_PERMISSIONS,
  CREATE_USER,
  UPDATE_USER,
  DELETE_USER,
  UNSET_DELETE_USER,
  GET_BY_ID_USER,
  UPDATE_PERMISSIONS_USER,
  UPDATE_ACCOUNT,
  MY_OPERATORS,
  CREATE_OPERATOR,
  UNSET_CREATE_OPERATOR,
  NEED_CREATE_IN_COREBANKING,
  SET_CREATED_IN_COREBANK,
  UNSET_CREATED_IN_COREBANK,
  SET_OPERATOR_STATIC_VALUE,
  SET_USER_CONTRACT_TERMS,
  SET_ROLES,
  SET_PENDING_PIX_KEY_PORTABILITIES,
  SET_CARDS_ELIGIBILITY,
} from '~/actions/actionTypes';
import { OperatorStatus } from '@portal/enum/accountStatus';

const initialState: reducers.UserReducer = {
  me: {
    id: null,
    createdAt: null,
    name: null,
    email: null,
    accountId: null,
    cellphone: null,
    login: null,
    mustChangePassword: false,
    mustChangePin: false,
    operatorStatus: OperatorStatus.AWAITING_LOGIN,
    account: {
      id: null,
      taxIdentifier: null,
      email: null,
      cellphone: null,
      createdAt: null,
      status: null,
      type: null,
      bornAt: null,
      motherName: null,
      bankAccountId: null,
      name: null,
      fantasyName: null,
      businessRegistration: null,
      companyType: null,
      cnae: null,
      businessLine: null,
      establishmentForm: null,
      representantId: null,
      financialStatistic: null,
      paymentAccounts: [],
      address: null,
    },
  },
  roles: [],
  needCreateInCoreBank: false,
  pendingDocuments: null,
  pendingDocumentsError: null,
  pendingDocumentsUploadSuccess: false,
  myUsersList: [],
  myUsersCount: null,
  myOperators: [],
  hasCreatedOperator: false,
  countOperators: null,
  permissionsList: [],
  createUserStatus: false,
  updateUserStatus: false,
  deleteUserStatus: false,
  updatePermissionsStatus: false,
  getByIdList: [],
  createInCoreBanking: null,
  multiAccessUser: null,
  userContractTerms: [],
  pendingPixKeyPortabilities: [],
  ispb: null,
  cardEligibility: false,
};

const userReducer = (
  state = initialState,
  action: any
): reducers.UserReducer => {
  const { payload, type } = action;
  switch (type) {
    case SET_ME:
      return {
        ...state,
        me: payload as models.User,
      };

    case SET_ISPB:
      return {
        ...state,
        ispb: payload as string | null,
      };

    case SET_ROLES:
      return {
        ...state,
        roles: payload as string[],
      };

    case SET_USER_CONTRACT_TERMS:
      return {
        ...state,
        userContractTerms: payload as models.ContractTerms[],
      };

    case SET_PENDING_DOCUMENTS:
      return {
        ...state,
        pendingDocuments: payload as models.PendingDocument[],
      };

    case SET_PENDING_DOCUMENTS_ERROR:
      return {
        ...state,
        pendingDocumentsError: payload as Error | null,
      };

    case SET_PENDING_DOCUMENTS_UPLOAD_SUCCESS:
      return {
        ...state,
        pendingDocumentsUploadSuccess: payload as boolean,
      };

    case MY_USERS:
      return {
        ...state,
        myUsersList: payload,
      };

    case MY_USERS_COUNT:
      return {
        ...state,
        myUsersCount: payload,
      };

    case MY_OPERATORS:
      return {
        ...state,
        myOperators: payload.rows,
        countOperators: payload.count,
      };

    case CREATE_OPERATOR:
      return {
        ...state,
        hasCreatedOperator: true,
      };

    case UNSET_CREATE_OPERATOR:
      return (state = {
        ...state,
        hasCreatedOperator: false,
      });

    case NEED_CREATE_IN_COREBANKING:
      return (state = {
        ...state,
        needCreateInCoreBank: payload,
      });

    case CREATE_USER:
      return {
        ...state,
        createUserStatus: payload,
      };

    case UPDATE_USER:
      return {
        ...state,
        updateUserStatus: payload,
      };

    case DELETE_USER:
      return {
        ...state,
        deleteUserStatus: payload,
      };

    case UNSET_DELETE_USER:
      return {
        ...state,
        deleteUserStatus: false,
      };

    case UPDATE_PERMISSIONS_USER:
      return {
        ...state,
        updatePermissionsStatus: payload,
      };

    case GET_BY_ID_USER:
      return {
        ...state,
        getByIdList: payload.roles,
        multiAccessUser: payload.name,
      };

    case AVAILABLE_PERMISSIONS:
      return {
        ...state,
        permissionsList: payload,
      };

    case UPDATE_ACCOUNT:
      return {
        ...state,
        me: {
          ...state.me,
          account: {
            ...state.me.account,
            [payload.key]: payload.value,
          },
        },
      };

    case SET_CREATED_IN_COREBANK:
      return {
        ...state,
        createInCoreBanking: true,
      };

    case UNSET_CREATED_IN_COREBANK:
      return {
        ...state,
        createInCoreBanking: false,
      };

    case SET_OPERATOR_STATIC_VALUE:
      return {
        ...state,
        me: { ...state.me, operatorStatus: payload },
      };

    case SET_PENDING_PIX_KEY_PORTABILITIES:
      return {
        ...state,
        pendingPixKeyPortabilities: payload ?? [],
      };

    case SET_CARDS_ELIGIBILITY:
      return {
        ...state,
        cardEligibility: payload,
      };

    default:
      return state;
  }
};

export default userReducer;
